import { formatCurrency } from '~/lib/coins';
import { GoldCoinIcon, SilverCoinIcon } from './icons';

interface CoinDisplayProps {
  coins: number;
  iconClassName?: string;
  className?: string;
  compactOnSmall?: boolean;
}

export function CoinDisplay({
  coins,
  iconClassName = 'w-4 h-4',
  className = '',
  compactOnSmall = false,
}: CoinDisplayProps) {
  const { gold, silver } = formatCurrency(coins);

  const iconHideClass = compactOnSmall
    ? 'hidden sm:inline-block'
    : '';

  return (
    <span
      className={`inline-flex items-center ${compactOnSmall ? 'gap-1 sm:gap-2' : 'gap-2'} ${className}`}
    >
      <span className="inline-flex items-center gap-0.5">
        <GoldCoinIcon
          className={`text-yellow-400 ${iconClassName} ${iconHideClass}`}
        />
        <span className="text-yellow-400">{gold}</span>
      </span>
      {silver > 0 && (
        <span className="inline-flex items-center gap-0.5">
          <SilverCoinIcon
            className={`text-gray-400 ${iconClassName} ${iconHideClass}`}
          />
          <span className="text-gray-400">{silver}</span>
        </span>
      )}
    </span>
  );
}
